<template>
  <v-container fluid>
    <v-data-table :headers="headers" :items="items" :loading="loading">
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>Resumen ventas</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-row justify="end">
            <v-col cols="12" md="3">
              <v-autocomplete
                v-model="tipo_doc"
                :items="items_tipo_doc"
                label="Tipo documento"
                item-text="nombre"
                item-value="id_tipo_doc_fiscal"
                outlined
                dense
                hide-details
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" md="3">
              <v-text-field
                v-model="fecha_desde"
                label="Desde"
                outlined
                hide-details
                dense
                type="date"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="3">
              <v-text-field
                v-model="fecha_hasta"
                label="Hasta"
                outlined
                hide-details
                dense
                type="date"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="auto">
              <v-btn @click="listarResumenes()" color="primary">Buscar</v-btn>
            </v-col>
          </v-row>
        </v-toolbar>
      </template>

      <template v-slot:[`item.fecha`]="{ item }">
        <span> {{ formatoFecha(item.fecha) }}</span>
      </template>

      <template v-slot:[`item.total_pagar`]="{ item }">
        <span> $ {{ Number(item.total_pagar).toFixed(2) }}</span>
      </template>

      <template v-slot:[`item.estatus`]="{ item }">
        <v-tooltip
          left
          color="primary"
          v-if="
            item.sello_recepcion == '' && item.resolucion_invalidacion == null
          "
        >
          <template v-slot:activator="{ on, attrs }">
            <v-icon color="primary" v-bind="attrs" v-on="on"
              >fa-regular fa-floppy-disk</v-icon
            >
          </template>
          <span>GUARDADO</span>
        </v-tooltip>

        <v-tooltip
          left
          color="success"
          v-else-if="
            item.sello_recepcion != '' && item.resolucion_invalidacion == null
          "
        >
          <template v-slot:activator="{ on, attrs }">
            <v-icon color="success" v-bind="attrs" v-on="on"
              >fa-regular fa-circle-check</v-icon
            >
          </template>
          <span>PROCESADO</span>
        </v-tooltip>

        <v-tooltip
          left
          color="error"
          v-else-if="
            item.resolucion_invalidacion != '' &&
            item.resolucion_invalidacion != null
          "
        >
          <template v-slot:activator="{ on, attrs }">
            <v-icon color="error" v-bind="attrs" v-on="on"
              >fa-solid fa-ban</v-icon
            >
          </template>
          <span>ANULADO</span>
        </v-tooltip>

        <v-tooltip left color="error" v-else-if="item.estatus == 'ERROR'">
          <template v-slot:activator="{ on, attrs }">
            <v-icon color="error" v-bind="attrs" v-on="on"
              >fa-solid fa-circle-exclamation</v-icon
            >
          </template>
          <span>ERROR</span>
        </v-tooltip>
      </template>

      <template v-slot:[`item.action_view_dte`]="{ item }">
        <v-icon @click="vistaPreviaPdf(item)" v-if="item.sello_recepcion == ''">
          fa-regular fa-file-pdf
        </v-icon>
        <v-icon
          @click="vistaPreviaPdfSello(item)"
          v-else-if="item.sello_recepcion != ''"
        >
          fa-regular fa-file-pdf
        </v-icon>
      </template>

      <template v-slot:[`item.action_view_ticket`]="{ item }">
        <v-icon @click="verTicket(item)"> fa-solid fa-receipt </v-icon>
      </template>

      <template v-slot:[`footer.prepend`] v-if="items.length > 0">
        <v-btn color="green" class="white--text" @click="generarExcel()"
          >Descargar</v-btn
        >
        <v-spacer></v-spacer>
        <span class="title"> Total: ${{ total_facturas.toFixed(2) }}</span>
        <v-spacer></v-spacer>
      </template>
    </v-data-table>

    <v-dialog v-model="dialog_preview_report" fullscreen persistent>
      <v-toolbar flat dense>
        <v-toolbar-title> DOCUMENTO </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-icon @click="dialog_preview_report = !dialog_preview_report">far fa-times-circle</v-icon>
      </v-toolbar>
      <iframe :src="base64_doc" id="myPDF" frameborder="0" />
    </v-dialog>
  </v-container>
</template>

<script>
import axios from "axios";
import settings from "@/settings/settings";
var XLSX = require("xlsx");
import { PDFDocument, StandardFonts, rgb, PageSizes } from "pdf-lib";
import printJS from "print-js";

export default {
  data: () => ({
    headers: [
      { text: "Número Control", value: "numero_control" },
      { text: "Fecha", value: "fecha" },
      { text: "Tipo Documento", value: "tipoDocFiscal.cod_doc_fiscal" },
      { text: "Cliente", value: "cliente.nombre" },
      { text: "Total", value: "total_pagar" },
      {
        text: "Ver DTE",
        value: "action_view_dte",
        align: "center",
        width: "80",
        sortable: false,
      },
      {
        text: "Ver ticket",
        value: "action_view_ticket",
        align: "center",
        width: "80",
        sortable: false,
      },
      { text: "Estatus", value: "estatus", align: "center" },
    ],
    items: [],
    fecha_desde:
      new Date().getFullYear() +
      "-" +
      ("0" + (new Date().getMonth() + 1)).slice(-2) +
      "-" +
      new Date().getDate(),
    fecha_hasta:
      new Date().getFullYear() +
      "-" +
      ("0" + (new Date().getMonth() + 1)).slice(-2) +
      "-" +
      new Date().getDate(),
    loading: false,
    items_excel: [],
    tipo_doc: 10,
    items_tipo_doc: [
      { id_tipo_doc_fiscal: 10, nombre: "CCF" },
      { id_tipo_doc_fiscal: 11, nombre: "FAC" },
      { id_tipo_doc_fiscal: 12, nombre: "FEX" },
      { id_tipo_doc_fiscal: 13, nombre: "NCR" },
      { id_tipo_doc_fiscal: 14, nombre: "NDB" },
      { id_tipo_doc_fiscal: 15, nombre: "NRM" },
      { id_tipo_doc_fiscal: 16, nombre: "FSE" },
    ],
    total_facturas: 0,
    loading_facturas: false,
    base64_doc: "",
    dialog_preview_report: false,
    snackbar_text: "",
    snackbar: false
  }),
  created() {
    this.listarResumenes();
  },
  methods: {
    async vistaPreviaPdf(item) {
      this.loading_facturas = true;

      axios
        .post("api/ServicioRecepciones/VistaPreviaDTE2", {
          cod_emp: this.$store.state.emp.id_empresa,
          tipoDte: item.tipoDocFiscal.cod_doc_fiscal,
          idFactura: item.id_factura,
          ambiente: await this.obtenerAmbiente(),
          es_previo: true,
        })
        .then((response) => {
          //console.log(response.data);
          this.loading_facturas = false;
          this.base64_doc = "data:application/pdf;base64," + response.data;
          this.dialog_preview_report = true;
        })
        .catch(() => {
          this.snackbar_text = "No se pudo generar el reporte";
          this.snackbar = true;
          this.loading_facturas = false;
        });
    },
    async vistaPreviaPdfSello(item) {
      this.loading_facturas = true;
      axios
        .post("api/ServicioRecepciones/DescargarFacturaWeb", {
          cod_emp: this.$store.state.emp.id_empresa,
          tipoDte: item.tipoDocFiscal.cod_doc_fiscal,
          idFactura: item.id_factura,
          ambiente: await this.obtenerAmbiente(),
          es_previo: false,
        })
        .then((response) => {
          //console.log(response.data);
          this.loading_facturas = false;
          this.base64_doc = "data:application/pdf;base64," + response.data;
          this.dialog_preview_report = true;
        })
        .catch(() => {
          this.snackbar_text = "No se pudo generar el reporte";
          this.snackbar = true;
          this.loading_facturas = false;
        });
    },
    async verTicket(item) {
      var items_productos = (
        await axios.get("api/Detallesfacturas/Listar/" + item.id_factura)
      ).data;

      const pdfDoc = await PDFDocument.create();
      const timesRomanFont = await pdfDoc.embedFont(
        StandardFonts.HelveticaBold
      );

      const page = pdfDoc.addPage([1100, 4276]);
      const { width, height } = page.getSize();
      var cont = 25;
      const fontSize = 50;
      const fontSizeTotales = fontSize + 15;

      var textWidth = timesRomanFont.widthOfTextAtSize(
        "LIBRERIA SOLO",
        fontSize
      );
      var textWidth2 = timesRomanFont.widthOfTextAtSize(
        "JOSE MARIO MEJIA ALVARENGA",
        fontSize
      );
      var textWidth3 = timesRomanFont.widthOfTextAtSize(
        "EXPEDIDO EN:",
        fontSize
      );
      var textWidth4 = timesRomanFont.widthOfTextAtSize(
        "SAN SALVADOR",
        fontSize
      );
      var textWidth5 = timesRomanFont.widthOfTextAtSize(
        "REGISTRO: 154051-0",
        fontSize
      );
      var textWidth6 = timesRomanFont.widthOfTextAtSize(
        "NIT: 0407-240749-001-8",
        fontSize
      );
      var textWidth7 = timesRomanFont.widthOfTextAtSize(
        "GRACIAS POR SU COMPRA VUELVA PRONTO",
        fontSize
      );
      var pageWidth = page.getWidth();
      const x = (pageWidth - textWidth) / 2;
      const x2 = (pageWidth - textWidth2) / 2;
      const x3 = (pageWidth - textWidth3) / 2;
      const x4 = (pageWidth - textWidth4) / 2;
      const x5 = (pageWidth - textWidth5) / 2;
      const x6 = (pageWidth - textWidth6) / 2;
      const x7 = (pageWidth - textWidth7) / 2;

      page.drawText("LIBRERIA SOLO", {
        x: x,
        y: height - 4 * fontSize,
        size: fontSize,
        font: timesRomanFont,
        color: rgb(0, 0, 0),
      });
      page.drawText("JOSE MARIO MEJIA ALVARENGA", {
        x: x2,
        y: height - 5 * fontSize,
        size: fontSize,
        font: timesRomanFont,
        color: rgb(0, 0, 0),
      });
      page.drawText("EXPEDIDO EN:", {
        x: x3,
        y: height - 7 * fontSize,
        size: fontSize,
        font: timesRomanFont,
        color: rgb(0, 0, 0),
      });
      page.drawText("SAN SALVADOR", {
        x: x4,
        y: height - 8 * fontSize,
        size: fontSize,
        font: timesRomanFont,
        color: rgb(0, 0, 0),
      });
      page.drawText("REGISTRO: 154051-0", {
        x: x5,
        y: height - 10 * fontSize,
        size: fontSize,
        font: timesRomanFont,
        color: rgb(0, 0, 0),
      });
      page.drawText("NIT: 0407-240749-001-8", {
        x: x6,
        y: height - 11 * fontSize,
        size: fontSize,
        font: timesRomanFont,
        color: rgb(0, 0, 0),
      });
      page.drawText("Código generación:" + item.codigo_generacion, {
        x: 1,
        y: height - 13 * fontSize,
        size: fontSize,
        font: timesRomanFont,
        color: rgb(0, 0, 0),
        lineHeight: 40,
        maxWidth: 1,
        wordBreaks: [":"],
      });
      page.drawText("Resolución:" + item.sello_recepcion, {
        x: 1,
        y: height - 16 * fontSize,
        size: fontSize,
        font: timesRomanFont,
        color: rgb(0, 0, 0),
        lineHeight: 40,
        maxWidth: 1,
        wordBreaks: [":"],
      });
      page.drawText("TICKET:" + item.numero_control, {
        x: 1,
        y: height - 19 * fontSize,
        size: fontSize,
        font: timesRomanFont,
        color: rgb(0, 0, 0),
        lineHeight: 40,
        maxWidth: 1,
        wordBreaks: [":"],
      });
      page.drawText("FECHA: " + this.formatoFecha(item.fecha), {
        x: 1,
        y: height - 22 * fontSize,
        size: fontSize,
        font: timesRomanFont,
        color: rgb(0, 0, 0),
      });
      page.drawText(
        "----------------------------------------------------------------------------------",
        {
          x: 1,
          y: height - 23 * fontSize,
          size: fontSize,
          font: timesRomanFont,
          color: rgb(0, 0, 0),
        }
      );
      page.drawText("DESCRIPCION\t\t\t\t\t\tTOTAL", {
        x: 1,
        y: height - 24 * fontSize,
        size: fontSize,
        font: timesRomanFont,
        color: rgb(0, 0, 0),
      });
      for (var i = 0; i < items_productos.length; i++) {
        cont = cont + 1;
        page.drawText(items_productos[i].descripcion, {
          x: 1,
          y: height - cont * fontSize,
          size: fontSize,
          font: timesRomanFont,
          color: rgb(0, 0, 0),
        });
        cont = cont + 1;
        page.drawText(
          items_productos[i].cantidad +
            "  * " +
            items_productos[i].precio.toFixed(2) +
            "\t\t\t\t\t\t\t\t  $" +
            items_productos[i].total.toFixed(2),
          {
            x: 20,
            y: height - cont * fontSize,
            size: fontSize,
            font: timesRomanFont,
            color: rgb(0, 0, 0),
          }
        );
      }
      page.drawText(
        "----------------------------------------------------------------------------------",
        {
          x: 1,
          y: height - (cont + 1) * fontSize,
          size: fontSize,
          font: timesRomanFont,
          color: rgb(0, 0, 0),
        }
      );
      page.drawText(
        "SUBTOTAL\t\t\t\t\t\t\t$" + Number(item.total_operacion).toFixed(2),
        {
          x: 20,
          y: height - (cont + 2) * fontSize - 15,
          size: fontSizeTotales,
          font: timesRomanFont,
          color: rgb(0, 0, 0),
        }
      );
      page.drawText(
        "DESCUENTO\t\t\t\t\t\t-$" + Number(item.descuento).toFixed(2),
        {
          x: 20,
          y: height - (cont + 3) * fontSize - 40,
          size: fontSizeTotales,
          font: timesRomanFont,
          color: rgb(0, 0, 0),
        }
      );
      page.drawText(
        "TOTAL\t\t\t\t\t\t\t\t\t$" + Number(item.total_pagar).toFixed(2),
        {
          x: 20,
          y: height - (cont + 4) * fontSize - 65,
          size: fontSizeTotales,
          font: timesRomanFont,
          color: rgb(0, 0, 0),
        }
      );
      page.drawText("GRACIAS POR SU COMPRA VUELVA PRONTO", {
        x: x7,
        y: height - (cont + 8) * fontSize - 65,
        size: fontSize - 3,
        font: timesRomanFont,
        color: rgb(0, 0, 0),
      });

      const pdfBytes = await pdfDoc.save();

      var u8 = new Uint8Array(pdfBytes);
      var b64encoded = btoa(String.fromCharCode.apply(null, u8));

      printJS({
        printable: b64encoded,
        type: "pdf",
        base64: true,
      });
    },
    listarResumenes() {
      if (this.fecha_desde && this.fecha_hasta) {
        this.loading = true;
        axios
          .post("api/Facturas/ExportarDocumentos", {
            id_empresa: this.$store.state.emp.id_empresa,
            desde: this.fecha_desde,
            hasta: this.fecha_hasta,
            id_tipo_doc_fiscal: this.tipo_doc,
          })
          .then((response) => {
            this.items = response.data;
            this.total_facturas = 0;
            this.items_excel = []; 

            for (let i = 0; i < response.data.length; i++) {
              let factura = response.data[i];
              
   
              let esAnulada = 
                factura.es_anulado === 1 || 
                factura.es_anulado === true || 
                (factura.resolucion_invalidacion != null && factura.resolucion_invalidacion !== '');
              
              let multiplicador = esAnulada ? -1 : 1;
              this.total_facturas = this.total_facturas + (factura.total_pagar * multiplicador);

              this.items_excel.push({
                "Número de control": factura.numero_control,
                "Código de generacion": factura.codigo_generacion,
                "Fecha": this.formatoFecha(factura.fecha),
                "Sello recepción": factura.sello_recepcion,
                "Fecha recepción": this.formatoFecha(factura.fecha_recepcion),
                "Cliente": factura.cliente.nombre,
                "Tipo pago": factura.tipo_pago,
                "Estado": esAnulada ? "ANULADA" : "PROCESADA",
                "Resolución Invalidación": factura.resolucion_invalidacion || "",
                "SubTotal": factura.sub_total * multiplicador,
                "Gravadas": factura.gravadas * multiplicador,
                "Iva": factura.iva * multiplicador,
                "Exentas": factura.exentas * multiplicador,
                "No sujetas": factura.no_sujetas * multiplicador,
                "Retención": factura.retencion * multiplicador,
                "Percepción": factura.percepcion * multiplicador,
                "Total operación": factura.total_operacion * multiplicador,
                "Total pagar": factura.total_pagar * multiplicador,
              });
            }
            this.loading = false;
          })
          .catch(() => {
            this.loading = false;
          });
      }
    },
    async obtenerAmbiente() {
      return (
        await axios.get(
          "api/DetallesEmpresas/ObtenerAmbiente/" +
          this.$store.state.emp.id_empresa
        )
      ).data;
    },
    generarExcel() {
      let data = XLSX.utils.json_to_sheet(this.items_excel);
      const workbook = XLSX.utils.book_new();
      const filename = "Resumen ventas";
      XLSX.utils.book_append_sheet(workbook, data, filename);
      XLSX.writeFile(workbook, `${filename}.xlsx`);
    },
    formatoFecha(item) {
      if (item) {
        return settings.metodos.formatoFechaHora(item);
      } else {
        return "";
      }
    },
  },
};
</script>